export const DISCOVER_FIELD = 'discover';
export const EXCLUDE_FIELD = 'exclude';
export const VALUE_FIELD = 'value';
export const SUBNET_FIELD = 'subnet';
export const VALUE_SUBNET_FIELD = 'value.subnet';
export const DESCRIPTION_FIELD = 'description';

export const SCOPE_TYPE = {
    exclude: 'exclude',
    monitor: 'monitor',
};

export const TYPE_SUBNET = 'subnet';
export const TYPE_IPADDR = 'ipAddress';
export const TYPE_RANGE = 'ipRange';
export const RANGE_SEPARATOR = '-';
